import { jsxs as r, jsx as e } from "react/jsx-runtime";

import { startOfMonth as a, endOfMonth as o, eachDayOfInterval as t, endOfWeek as l, startOfWeek as s, getDay as d } from "date-fns";

import { useMemo as i } from "react";

import m from "@ui-components-3/ui/lib/utils/classNames";

import n from "./MonthCalendarCell.js";

import { SCHEDULE_WEEK_STARTS_ON as c, calendarWeekDays as p } from "../../../utils.js";

import { useProviderSchedule as u } from "../../../hooks/useProviderSchedule.js";

const f = () => {
    const {isMobile: f, date: h, variantClassNames: g} = u(), b = !f, x = i((() => {
        const r = a(h), e = o(h);
        return t({
            start: b ? s(r, {
                weekStartsOn: c
            }) : r,
            end: b ? l(e, {
                weekStartsOn: c
            }) : e
        });
    }), [ h, b ]), v = i((() => b ? Array.from({
        length: d(x[0])
    }, ((r, e) => e)) : []), [ b, x ]);
    return r("div", {
        "aria-label": "Month Calendar",
        children: [ e("div", {
            className: m("border-1 border-1 -ml-[1px] hidden auto-rows-fr grid-cols-[repeat(7,1fr)] rounded-t-lg border border-neutral-400 py-3 xl:grid", g.bgLight),
            children: p.map((r => e("div", {
                className: "text-primary-700 typography-body-l mx-3 font-medium",
                children: e("p", {
                    children: r.toUpperCase()
                })
            }, r)))
        }), r("div", {
            className: m("grid flex-1 auto-rows-fr grid-cols-1 xl:grid-cols-[repeat(7,1fr)]"),
            children: [ !!b && v?.map((r => e("div", {
                className: "hidden xl:block"
            }, r))), x.map(((r, a) => e(n, {
                day: r,
                className: m("last:xl:rounded-br-lg", 
                // TODO - use :nth-last-7 pseudo-selector class and move this className to MonthCalendarCell component itself
                // after migrating to Tailwind v4
                // https://tailwindcss.com/docs/hover-focus-and-other-states#nth-last-child
                a === x.length - 7 && "xl:rounded-bl-lg")
            }, a))) ]
        }) ]
    });
};

export { f as default };
//# sourceMappingURL=index.js.map
